import {
  GET_STATUT_ENTREPRENEURS
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_STATUT_ENTREPRENEURS] (state, data) {
    state.all = data
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/statutEntrepreneurs.js